import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'

export const footmarkShopList = [
  {
    title: t('我收藏的店铺'),
    type: 'collect',
    routerPath: useRtfix('CollectProduct', { query: { tab: '1' } })
  },
  {
    title: t('我看过的店铺'),
    type: 'look',
    routerPath: useRtfix('FootPrint', { query: { tab: '1' } })
  },
  {
    title: t('我买过的店铺'),
    type: 'buy',
    routerPath: useRtfix('AfterPurchase', { query: { tab: '1' } })
  }
]

export const footmarkGoodsList = [
  {
    title: t('我看过的商品'),
    type: 'look',
    routerPath: useRtfix('FootPrint')
  },
  {
    title: t('我买过的商品'),
    type: 'buy',
    routerPath: useRtfix('AfterPurchase')
  },
  {
    title: t('我收藏的商品'),
    type: 'collect',
    routerPath: useRtfix('CollectProduct')
  }
]
